module.exports = __webpack_public_path__ + "static/img/1_0036.d44c057.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0036.jpg
// module id = bsv9
// module chunks = 0